/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ActivityType, Campaign, CampaignActivity, Lookup } from "../../api/types/types";

import { parseValueToOptionalNumber } from "./campaign-response-lookup-utils";
import { findLookupValue } from "./LookupSelect";
import { CampaignFormData } from "./types";

export const transformFormDataToCampaignResponses = (
  campaigns: Campaign[],
  formData: Record<string, CampaignFormData>,
  competitorLookup: Lookup | undefined
): CampaignActivity[] => {
  return campaigns
    .filter((campaign) => {
      return Boolean(campaign.campaignId && formData[campaign.campaignId]?.responseCode);
    })
    .map((campaign) => {
      const data = formData[campaign.campaignId || ""];

      const responseCode = parseValueToOptionalNumber(data.responseCode);
      const responseType = parseValueToOptionalNumber(data.type);
      const responseReason = parseValueToOptionalNumber(data.reason);

      let competitorId: string | undefined;
      let competitorName: string | undefined;
      if (data.competitor) {
        const competitorValue = findLookupValue(competitorLookup, data.competitor);
        competitorId = competitorValue?.id || competitorValue?.value?.toString();
        competitorName = competitorValue?.label;
      }

      return {
        accountNumber: campaign.accountNumber,
        campaignActivityId: campaign.campaignActivityId,
        campaignName: campaign.campaignName,
        campaignCode: campaign.campaignCode,
        campaignId: campaign.campaignId,
        activityType: campaign.activityType as ActivityType,
        activityStatus: campaign.activityStatus,
        subject: campaign.subject,
        proposedStart: campaign.proposedStart || undefined,
        proposedEnd: campaign.proposedEnd || undefined,
        actualStart: campaign.actualStart || undefined,
        actualEnd: campaign.actualEnd || undefined,
        linkToSharePoint: campaign.linkToSharePoint,
        description: campaign.description,
        responseCode,
        responseCodeName: campaign.responseCodeName || undefined,
        responseType,
        responseReason,
        competitorName,
        competitorId,
        responseDescription: data.notes || undefined,
      };
    });
};
